<template>
    <!-- attrId = 1200000094 为产地 -->
    <mc-select
        v-model="innerValue"
        v-bind="$attrs"
        remote
        filterable
        :value-key="attrId === 1200000094 ? 'valuePath' : 'value'"
        :label-key="attrId === 1200000094 ? 'valuePath' : 'value'"
        placeholder="请先输入再进行选择"
        :source="valueList"
        :remote-method="remoteMethod"
        :multiple="false"
        @scroll-bottom="scrollBottom"
    />
</template>

<script>
import {
    ref, computed, getCurrentInstance, onMounted,
} from '@vue/composition-api';
import { hPost } from '@mcfe/tools';

export default {
    name: 'SgAttrSelect',

    props: {
        value: {
            type: Array,
            default: () => ([]),
        },

        attrId: {
            type: [String, Number],
            default: '',
        },
    },

    setup() {
        const { proxy, props } = getCurrentInstance();
        const valueList = ref([]); // 属性可选值
        const allowRequest = ref(true); // 是否允许继续请求
        const offset = ref(1); // 当前页码
        const attrName = ref(''); // 属性名

        // 获取属性值列表
        const getValue = async () => {
            if (!attrName.value) return;
            // 构造请求参数
            const params = {
                attrId: props.attrId, // 扩展属性id
                keyword: attrName.value, // 属性名
                page: {
                    offset: offset.value,
                    limit: 20,
                },
            };
            // 获取属性值列表
            const res = await hPost('/api/vss/shepherd/SgProductCommandTService/querySgAttrValueList', params).catch(() => {});
            // 将获取到的属性值添加到valueList中
            valueList.value = [...valueList.value, ...res.sgProductAttrValues];
            // 如果获取到的属性值数量小于20，则不再允许请求
            if (res?.sgProductAttrValues.length < 20) allowRequest.value = false;
        };

        const innerValue = computed({
            // 获取 props.value 的值
            get() {
                return props.value[0]?.value;
            },
            // 设置 props.value 的值，并通过 emit 方法触发 input 事件，通知父组件 value 的变化
            set(val) {
                const attrValues = valueList.value.find((item) => val === item.valuePath);
                proxy.$emit('input', [{ id: +attrValues.valueId, value: attrValues.valuePath }]);
            },
        });

        // 触底事件处理函数
        const scrollBottom = () => {
            // 如果不允许请求，直接返回
            if (!allowRequest.value) return;
            // 否则，页码加1
            offset.value += 1;
            // 获取属性值列表
            getValue();
        };

        // 模糊搜索方法
        const remoteMethod = (name) => {
            // 设置属性名为输入的搜索关键词
            attrName.value = name;
            // 清空属性值列表
            valueList.value = [];
            // 重置页码为1
            offset.value = 1;
            // 允许请求
            allowRequest.value = true;
            // 获取属性值列表
            getValue();
        };

        onMounted(() => {
            // 如果props.value存在值，则获取对应的属性值列表
            if (props.value.length) getValue(props.value);
            // 获取属性值列表
            getValue();
        });

        return {
            valueList,
            allowRequest,
            offset,
            attrName,
            getValue,
            innerValue,
            scrollBottom,
            remoteMethod,
        };
    },
};
</script>
